import { render, staticRenderFns } from "./OcrModal.vue?vue&type=template&id=762ce403&scoped=true"
import script from "./OcrModal.vue?vue&type=script&lang=js"
export * from "./OcrModal.vue?vue&type=script&lang=js"
import style0 from "./OcrModal.vue?vue&type=style&index=0&id=762ce403&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762ce403",
  null
  
)

export default component.exports